import React from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { Header } from '../components/Header';
export function ThankYouPage() {
  return <Box w="100vw" h="100vh" bg="white" overflow="auto" data-id="element-395">
      <Header data-id="element-396" />

      <Box pt="64px" px={6} py={6} data-id="element-397">
        <Box border="2px solid #006666" borderRadius="md" bg="white" maxW="700px" p={6} className="ml-[37px] mr-[37px] mt-[60px] mb-[60px]" data-id="element-398">
          <Text fontSize="2xl" fontWeight="bold" color="#004D40" mb={4} data-id="element-399">
            Thank you for Registering
          </Text>

          <Text fontSize="md" fontWeight="bold" color="#004D40" mb={0} data-id="element-400">
            IMPORTANT: CHECK YOUR EMAIL FOR A CONFIRMATION LINK.
          </Text>
          <Text fontSize="md" fontWeight="bold" color="#004D40" mb={4} data-id="element-401">
            THE LINK EXPIRES IN 20 MINUTES!
          </Text>

          <VStack align="start" spacing={1.5} data-id="element-402">
            <Text fontSize="md" color="gray.700" data-id="element-403">
              1) You'll receive an email with a confirmation link.
            </Text>
            <Text fontSize="md" color="gray.700" data-id="element-404">
              2) Click on that link to confirm your entered email is accurate.
            </Text>
            <Text fontSize="md" color="gray.700" data-id="element-405">
              3) When you do that, P & L will also receive an email about your
              registration.
            </Text>
            <Text fontSize="md" color="gray.700" data-id="element-406">
              4) They will then approve the registration and send you an email
              to let you know you can now log in to the site.
            </Text>
          </VStack>
        </Box>
      </Box>
    </Box>;
}